import type { Container } from 'pixi.js';
import type { Layout } from '../populateLayouts/types/Layout';
import { onLayoutPopulated } from '../populate';
import { applyLayoutState } from '../populateLayouts/applyLayoutState';

type LayoutWithDefaultSkin = {
  root: Container;
  data?: { defaultSkin?: string };
};

export function layoutApplyDefaultSkin(): void {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  onLayoutPopulated.connect((layout: Layout ) => {
    if (!(layout as LayoutWithDefaultSkin)?.data?.defaultSkin) return;
    
    const layoutWithDefaultSkin = layout as LayoutWithDefaultSkin;
    if (layoutWithDefaultSkin.data?.defaultSkin) applyLayoutState(layout, layoutWithDefaultSkin.data?.defaultSkin);
  });
}
